<template>
  <div class="list-container">
    <div class="header">
      <h1>企业站信息管理后台</h1>
      <el-button type="danger" @click="logout">退出登录</el-button>
    </div>
    
    <div class="main-content">
      <el-menu
        :default-active="currentMenu"
        class="sidebar"
        @select="switchMenu"
      >
        <el-menu-item v-for="menu in menus" :key="menu.id" :index="menu.id">
          {{ menu.name }}
        </el-menu-item>
      </el-menu>

      <div class="content-area">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListPage',
  data() {
    return {
      currentMenu: 'enterprise',
      menus: [
        { id: 'enterprise', name: '用户信息' },
        { id: 'productcategory', name: '产品分类' },
        { id: 'newscategory', name: '新闻分类' },
        { id: 'casecategory', name: '案例分类' },
        { id: 'product', name: '产品中心' },
        { id: 'news', name: '新闻资讯' },
        { id: 'case', name: '案例' },
        { id: 'solution', name: '解决方案' },
        { id: 'banner', name: '轮播图' }
      ]
    }
  },
  created() {
    if (!localStorage.getItem('isLoggedIn')) {
      this.$router.push('/login')
    }
    this.currentMenu = this.$route.path.split('/')[2] || 'enterprise'
  },
  methods: {
    switchMenu(menuId) {
      this.currentMenu = menuId
      this.$router.push(`/list/${menuId}`)
    },
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('isLoggedIn')
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-container {
  padding: 10px;
  margin: 0 auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.header h1 {
  color: #333;
  font-size: 28px;
  margin: 0;
}

.main-content {
  display: flex;
  gap: 10px;
  min-height: calc(100vh - 120px);
}

.sidebar {
  width: 200px;
  flex-shrink: 0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.content-area {
  flex: 1;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
}
</style>
